// Entrypoint that rounds up footnotes and instantiates sidenote components for each, stuffing the content inside
'use strict';

import fireAllMicroScripts from "./micro-scripts/fireAllMicroScripts";
import renderComponentSwaps from "./components/renderComponentSwaps";

fireAllMicroScripts();

renderComponentSwaps();

